<ft-pending-changes-panel-ng #panel [live]="panelLiveRoot"
                             (save)="onPanelSave($event)" (cancelled)="onPanelCancel()" />
<ft-field-editor-modal [config]="fieldEditorConfig()" (closed)="fieldEditorConfig.set(null)" />

<!-- ftModal phase 2 / WS3: the confirmation-email-image "Banner image" modal, native. Replaces
     the bridged <ft-modal id="modals.prestay.confirmation.imageLibrary"
     ft-snapshot="model.styling,model.isUseDefaultImage"> compile: native ft-modal-overlay +
     ft-modal-chrome-ng hosting the inline "use default image" .ft-switch + the native
     ft-image-library-ng (image-type 3). DEFERRED-SAVE (v1 had no on-done): selecting an image /
     toggling the switch mutates model.styling.backgroundImage in place; Done closes + nudges the
     native pending-changes panel (recompute), which detects the diff (Save -> saveEmailImageStyling);
     X/Cancel reverts the snapshotted model.styling + model.isUseDefaultImage. -->
<ft-modal-overlay [open]="imageLibraryModalOpen()">
  @if (imageLibraryModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.BannerImage' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onImageLibraryDone()"
    (cancel)="onImageLibraryCancel()"
  >
    <div class="modal-panel">
      {{ 'flipto.account.UseDefaultImage' | translate }}
      <!-- Inline .ft-switch DOM (NOT the <ft-switch> FtSwitchComponent element) — its selector
           collides with the AngularJS ftSwitch E-directive at <body> in this CDK overlay. The
           DOM is byte-identical to FtSwitchComponent's template. -->
      <div class="ft-switch">
        <input
          class="ft-switch-toggle"
          type="checkbox"
          [id]="bannerSwitchUid"
          [checked]="model().isUseDefaultImage"
          (change)="onImageLibrarySwitchToggle($event)"
        />
        <label [attr.for]="bannerSwitchUid"></label>
      </div>
    </div>
    @if (!model().isUseDefaultImage) {
      <ft-image-library-ng
        [images]="model().propertyImages"
        [propertyId]="model().propertyId"
        [imageType]="3"
        view="list"
        (imageSelected)="updateImage($event)"
       />
    }
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- ftModal phase 2 / WS3: the BannerSize "dimensions" modal (pre-arrival-email /
     poststay-email-image / confirmation-email-image banners), native. Replaces the bridged
     dimensionsModalHtml() fieldsEditor.compile (ft-snapshot="model.styling": number inputs
     desktopWidth/mobileWidth + add/remove mobile). DEFERRED-save (v1 had no on-done): editing a
     width mutates model.styling -> the native pending-changes panel detects it ->
     saveEmailImageStyling. Done closes + recompute; X/Cancel reverts the model.styling snapshot. -->
<ft-modal-overlay [open]="dimensionsModalOpen()">
  @if (dimensionsModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.BannerSize' | translate"
    [headerDescription]="'flipto.account.BannerSizeDescription' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onDimensionsDone()"
    (cancel)="onDimensionsCancel()"
  >
    <div class="modal-section-heading">{{ 'flipto.account.WidthDesktop' | translate }}</div>
    <div class="modal-panel modal-panel-input">
      <input
        type="number"
        [(ngModel)]="model().styling.desktopWidth"
        [ngModelOptions]="{ standalone: true }"
        required
        min="0"
        max="2048"
        [placeholder]="'flipto.account.Width' | translate"
      />
    </div>
    @if (!!model().styling?.mobileWidth) {
      <div class="modal-section-heading">{{ 'flipto.account.WidthMobile' | translate }}</div>
      <div class="modal-panel modal-panel-input">
        <input
          type="number"
          [(ngModel)]="model().styling.mobileWidth"
          [ngModelOptions]="{ standalone: true }"
          required
          min="0"
          max="2048"
          [placeholder]="'flipto.account.Width' | translate"
        />
        <div class="modal-panel-actions"><a class="action btn-delete-item" (click)="removeMobileWidth()"></a></div>
      </div>
    }
    <div class="modal-footer-align">
      @if (!model().styling?.mobileWidth) {
        <a class="ft-btn ft-btn-plus-1 ft-btn-outline-light" (click)="model().styling.mobileWidth = 320">{{ 'flipto.account.AddMobileBanner' | translate }}</a>
      }
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- B2 (WS5 #10 Stage B): the 5 email-template-picker modals, native — replace the bridged
     fieldsEditor.compile <ft-modal> strings (StylingEmailTemplate / ReminderEmails /
     Reengagement controllers). v1 default chrome (Done=PUT+close, X/Cancel=close[+rollback]);
     header-text restored to the {{'flipto.account.EmailTemplate'|translate}} v1 expression (the
     bridged single-picker string had regressed to a literal "Email template"). The .ft-dropdown
     is the v1 ft-click-class toggle-class="active" inline recipe (2y create-contest twin:
     item-click closes via bubbling, outside-click closes via the document handler). Each
     show-method no-ops at templates.length<2 (data-gated on quebec) → pixel-inert at the gate. -->

<!-- single email-template picker — followup + the 6 isEmailTemplatePicker types (invitation-email,
     finalistsEmail, reminderEmail, activityEmail, winnerEmail, homepageEmail). on-done=updateEmailTemplate
     (Styling.putEmail). invitation-email ALONE carried ft-snapshot in v1 (cancel rolls back the
     selectedTemplate) — armed conditionally in showEmailTemplateModal. -->
<ft-modal-overlay [open]="emailTemplateModalOpen()">
  @if (emailTemplateModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.EmailTemplate' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onEmailTemplateDone()"
    (cancel)="onEmailTemplateCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div class="ft-dropdown" [class.active]="dropdownActive()" (click)="toggleDropdown($event)">
        <a class="ft-dropdown-toggle"><span>{{ emailTemplate().selectedTemplate?.name }}</span> <i class="ft-icn-caret-down"></i></a>
        <ul class="ft-dropdown-menu">
          @for (template of emailTemplate().templates; track template) {
          <li (click)="emailTemplate().selectedTemplate = template"><a>{{ template.name }}</a></li>
          }
        </ul>
      </div>
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- reminder-emails: non-view picker (edit-reminder-emails-styles.html editNonViewTemplate). -->
<ft-modal-overlay [open]="reminderNonViewModalOpen()">
  @if (reminderNonViewModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.EmailTemplate' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onReminderNonViewDone()"
    (cancel)="onReminderNonViewCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div class="ft-dropdown" [class.active]="dropdownActive()" (click)="toggleDropdown($event)">
        <a class="ft-dropdown-toggle"><span>{{ emailTemplate().nonViewSelectedTemplate?.name }}</span> <i class="ft-icn-caret-down"></i></a>
        <ul class="ft-dropdown-menu">
          @for (template of emailTemplate().nonViewTemplates; track template) {
          <li (click)="emailTemplate().nonViewSelectedTemplate = template"><a>{{ template.name }}</a></li>
          }
        </ul>
      </div>
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- reminder-emails: after-view picker (editAfterViewTemplate). -->
<ft-modal-overlay [open]="reminderAfterViewModalOpen()">
  @if (reminderAfterViewModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.EmailTemplate' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onReminderAfterViewDone()"
    (cancel)="onReminderAfterViewCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div class="ft-dropdown" [class.active]="dropdownActive()" (click)="toggleDropdown($event)">
        <a class="ft-dropdown-toggle"><span>{{ emailTemplate().afterViewSelectedTemplate?.name }}</span> <i class="ft-icn-caret-down"></i></a>
        <ul class="ft-dropdown-menu">
          @for (template of emailTemplate().afterViewTemplates; track template) {
          <li (click)="emailTemplate().afterViewSelectedTemplate = template"><a>{{ template.name }}</a></li>
          }
        </ul>
      </div>
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- reengagement-emails: no-quote picker (edit-reengagement-emails-styles.html editNoQuoteTemplate). -->
<ft-modal-overlay [open]="reengagementNoQuoteModalOpen()">
  @if (reengagementNoQuoteModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.EmailTemplate' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onReengagementNoQuoteDone()"
    (cancel)="onReengagementNoQuoteCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div class="ft-dropdown" [class.active]="dropdownActive()" (click)="toggleDropdown($event)">
        <a class="ft-dropdown-toggle"><span>{{ emailTemplate().noQuoteSelectedTemplate?.name }}</span> <i class="ft-icn-caret-down"></i></a>
        <ul class="ft-dropdown-menu">
          @for (template of emailTemplate().noQuoteTemplates; track template) {
          <li (click)="emailTemplate().noQuoteSelectedTemplate = template"><a>{{ template.name }}</a></li>
          }
        </ul>
      </div>
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- reengagement-emails: no-photo picker (editNoPhotoTemplate). NOTE: in v1 this modal NEVER
     opened — the read-view panel's ft-targets-modal="…editnoPhotoTemplate" (lowercase n,
     edit-reengagement-emails-styles.html:44) does not match the registered id editNoPhotoTemplate
     and ftModal.findModal is case-sensitive (modal.js:122-125) → show() threw. The WS4 native
     read-view already targets the correct id via showReengagementNoPhotoTemplateModal(), silently
     fixing the bug (a pre-existing, gate-blind divergence kept here per the 2y "corruption ≠
     preserve-bug" precedent; documented, not gate-proven). -->
<ft-modal-overlay [open]="reengagementNoPhotoModalOpen()">
  @if (reengagementNoPhotoModalOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.EmailTemplate' | translate"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="onReengagementNoPhotoDone()"
    (cancel)="onReengagementNoPhotoCancel()"
  >
    <div class="modal-panel modal-panel-input">
      <div class="ft-dropdown" [class.active]="dropdownActive()" (click)="toggleDropdown($event)">
        <a class="ft-dropdown-toggle"><span>{{ emailTemplate().noPhotoSelectedTemplate?.name }}</span> <i class="ft-icn-caret-down"></i></a>
        <ul class="ft-dropdown-menu">
          @for (template of emailTemplate().noPhotoTemplates; track template) {
          <li (click)="emailTemplate().noPhotoSelectedTemplate = template"><a>{{ template.name }}</a></li>
          }
        </ul>
      </div>
    </div>
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>

<!-- B3 (RESTORE §8.2): the confirmation email-images gallery preview modal, native. Maps v1
     emailImagesPreview.html:25-82 (the <ft-modal id="modals.emailImages.confirmation.preview">
     that lived INSIDE the bridged widget). Opened by the ConfirmationBannerPreview .ft-panel
     (openGallery, gated by the update-email-images task); per-language desktop/mobile toggle +
     Refresh (ftTasks key generate-email-image-{imageUUID}-{code}) + ft-image-ng previews. Only the
     confirmation case (v1 only compiled the connect-to-hub widget there). -->
@if (touchpointType() === 'confirmation-email-image') {
<ft-modal-overlay [open]="galleryOpen()">
  @if (galleryOpen()) {
  <ft-modal-chrome-ng
    [headerText]="'flipto.account.ConfirmationBannerPreview' | translate"
    [headerDescription]="'flipto.account.ImagePreviewsModalSummary' | translate"
    doneText="Done"
    size="sm"
    [doneVisible]="true"
    [cancelVisible]="true"
    [footerVisible]="true"
    [footerCancelVisible]="false"
    (done)="closeGallery()"
    (cancel)="closeGallery()"
  >
    <div class="modal-panel" [hidden]="model().styling?.languages?.length">{{ 'flipto.account.ThereAreNoPreviews' | translate }}</div>

    @for (image of model().styling?.languages; track image) {
      <div class="modal-panel preview-editor" [hidden]="!image.imageUUID">
        <div class="ta-toolbar btn-toolbar">
          @if (hasMobile(image)) {
            <div class="ft-btn-group view-switcher-toggle">
              <button class="ft-btn btn-default btn-desktop" type="button" [class.active]="isDesktop(image)" (click)="setDesktop(image, true)">
                <i class="icon ft-icn-device-desktop"></i>
              </button>
              <button class="ft-btn btn-default btn-mobile" type="button" [class.active]="!isDesktop(image)" (click)="setDesktop(image, false)">
                <i class="icon ft-icn-device-mobile"></i>
              </button>
            </div>
          }

          <button class="ft-btn btn-refresh ft-btn-text" [disabled]="isImagePending(image)" (click)="onGalleryRefresh(image)">
            <i class="icon ft-icn-refresh"></i> {{ 'flipto.account.RefreshImage' | translate }}
          </button>
        </div>

        <div class="preview-image-container">
          <div class="preview-image-content">
            @if (isDesktop(image)) {
              <ft-image-ng class="preview-image" [alwaysVisible]="true" [src]="azureUrl(image.imageUUID, cdnSuffixForDesktopImage)" />
            }
            @if (!isDesktop(image)) {
              <ft-image-ng class="preview-image" [alwaysVisible]="true" [src]="azureUrl(image.imageUUID, 'small')" />
            }

            <div class="preview-image-loader" [hidden]="!isImagePending(image)">{{ 'flipto.account.Loading' | translate }}</div>
          </div>
        </div>

        <div class="language-code">{{ image.name }}</div>
      </div>
    }
  </ft-modal-chrome-ng>
  }
</ft-modal-overlay>
}

@switch (stylingBranch) {

  <!-- WS4 inc 4-next: followup STYLING (edit-followup-styles.html). Two ft-nav-pane
       screens: 'followup' = the email-template picker (nested StylingEmailTemplateController
       ported in-component, Styling.getEmail/putEmail + the emailTemplateModal bridged) and
       'share' = a single FLAT CSS panel on model.styling.advancedCss (snapshot model.styling,
       NOT bookingEngines). -->
  @case ('followup') {
  <section class="ft-section ft-config-section has-sidenav">
    <div class="ft-container">
      <div class="ft-row">
        <div class="ft-col-25">
          <ul class="nav editor-nav">
            <li><a class="followup" style="display: inline-block;" (click)="screenName.set('followup')"
                   [class.active]="screenName() === 'followup'"
                   [innerHTML]="'flipto.account.platform.preStay.touchpoints.FollowupEmail' | translate"></a></li>
            <li><a class="share" style="display: inline-block;" (click)="screenName.set('share')"
                   [class.active]="screenName() === 'share'"
                   [innerHTML]="'flipto.account.platform.preStay.touchpoints.SharePage' | translate"></a></li>
          </ul>
        </div>
        <div class="ft-col-75">
          <ft-screen name="followup">
            <div [hidden]="screenName() !== 'followup'">
              <div class="ft-panel" (click)="showEmailTemplateModal()" [class.read-only]="emailTemplate().templates.length < 2">
                <div class="ft-row">
                  <div class="ft-col-33">
                    <div class="ft-label">{{ 'flipto.account.EmailTemplate' | translate }}:</div>
                  </div>
                  <div class="ft-col-66">
                    <div class="text" [hidden]="!emailTemplate().templates.length">{{ emailTemplate().templates.length > 1 ? emailTemplate().selectedTemplate?.name : 'Default' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </ft-screen>

          <ft-screen name="share">
            <div [hidden]="screenName() !== 'share'">
              <div class="ft-panel" ft-modal-fields-editor (click)="editFollowupCss()">
                <div class="ft-row">
                  <div class="ft-col-33">
                    <div class="ft-label">CSS:</div>
                  </div>
                  <div class="ft-col-66">
                    <div class="css-text">{{ model().styling && model().styling['advancedCss'] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </ft-screen>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 4-next: pre-arrival-email BANNER styling (photo-advocacy,
       edit-pre-arrival-email-styles.html). BannerSize read-row (opens the bridged
       dimensions <ft-modal>) + a flat TouchpointCSS panel. Save = saveEmailImageStyling
       (whole-object PUT), NOT commit. The css-text reproduces the v1 ft-placeholder
       (Click to edit when empty). -->
  @case ('pre-arrival-email') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" (click)="showDimensionsModal()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.BannerSize' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div>{{ model().styling?.desktopWidth }}px&nbsp;{{ 'flipto.account.WidthDesktop' | translate | lowercase }}</div>
            @if (model().styling?.mobileWidth) {
              <div>{{ model().styling?.mobileWidth }}px&nbsp;{{ 'flipto.account.WidthMobile' | translate | lowercase }}</div>
            }
          </div>
        </div>
      </div>
      <div class="ft-panel last" ft-modal-fields-editor (click)="editBannerCss()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.TouchpointCSS' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div class="css-text">{{ bannerCss }}@if (!bannerCss) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind #6: photo-advocacy POSTSTAY-EMAIL-IMAGE banner styling
       (edit-poststay-email-image-styles.html). Like pre-arrival (BannerSize dimensions modal +
       flat touchpointCSS panel + saveEmailImageStyling) but with a "CSS" label (not TouchpointCSS)
       and its own dimensions modal id; NO BannerImage/SignalR preview. -->
  @case ('poststay-email-image') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" (click)="showDimensionsModal('modals.photoadvocacy.poststayemailimage.dimensions')">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.BannerSize' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div>{{ model().styling?.desktopWidth }}px&nbsp;{{ 'flipto.account.WidthDesktop' | translate | lowercase }}</div>
            @if (model().styling?.mobileWidth) {
              <div>{{ model().styling?.mobileWidth }}px&nbsp;{{ 'flipto.account.WidthMobile' | translate | lowercase }}</div>
            }
          </div>
        </div>
      </div>
      <div class="ft-panel last" ft-modal-fields-editor (click)="editBannerCss()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.CSS' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div class="css-text">{{ bannerCss }}@if (!bannerCss) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 4-next: confirmation-email-image BANNER styling (pre-stay,
       edit-confirmation-email-image-styles.html — the heaviest banner). BannerSize +
       BannerImage (thumbnail + bridged image-library modal w/ ft-switch + ft-image-library) +
       ConfirmationBannerPreview (bridged ft-email-images-preview SignalR widget) + CSS. Save =
       saveEmailImageStyling; snapshot "model.styling,model.isUseDefaultImage" + setupStylingSnapshot. -->
  @case ('confirmation-email-image') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" (click)="showDimensionsModal('modals.prestay.confirmation.dimensions')">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.BannerSize' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div>{{ model().styling?.desktopWidth }}px&nbsp;{{ 'flipto.account.WidthDesktop' | translate | lowercase }}</div>
            @if (model().styling?.mobileWidth) {
              <div>{{ model().styling?.mobileWidth }}px&nbsp;{{ 'flipto.account.WidthMobile' | translate | lowercase }}</div>
            }
          </div>
        </div>
      </div>

      <div class="ft-panel" (click)="showImageLibraryModal()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.BannerImage' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div class="thumbnail-image" [ftBackgroundImage]="(model().styling?.backgroundImage || model().defaultBackgroundImageUrl) || ''">
              <span class="placeholder" [hidden]="model().styling?.backgroundImage || model().defaultBackgroundImageUrl">{{ 'flipto.account.AddAnImage' | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- B3: ConfirmationBannerPreview — native read-view twin (thumbnail) + the RESTORED gallery
           opener. v1 (edit-confirmation-email-image-styles.html:44-62) put ft-targets-modal=
           "modals.emailImages.confirmation.preview" on the whole .ft-panel (gated by
           ft-no-targets-modal-if-task-pending="update-email-images"); the WS4 native port DROPPED
           that opener. openGallery() restores it (the gate is in the method). The gallery modal is
           the sibling ft-modal-overlay above. The twin renders the same thumbnail markup the bridged
           widget did (read-view pixel baseline preserved); it self-renders nothing when empty. -->
      <div class="ft-panel" (click)="openGallery()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.ConfirmationBannerPreview' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            @if (!model().styling?.languages?.length) {<span class="placeholder">{{ 'flipto.account.platform.ClickToPreview' | translate }}</span>}
            <ft-email-images-preview-ng [images]="model().styling?.languages" emailImageType="confirmation" />
          </div>
        </div>
      </div>

      <div class="ft-panel last" ft-modal-fields-editor (click)="editBannerCss()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.CSS' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div class="css-text">{{ bannerCss }}@if (!bannerCss) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: post-stay INVITATION-EMAIL styling (edit-invitation-email-styles.html).
       JUST the email-template picker (no nav-pane, no CSS screen) — reuses the followup styling
       email-template machinery (emailTemplate model / showEmailTemplateModal / loadEmailTemplate /
       the bridged emailTemplateModal). templates.length<2 on quebec → shows 'Default'. -->
  @case ('invitation-email') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" (click)="showEmailTemplateModal()" [class.read-only]="emailTemplate().templates.length < 2">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.EmailTemplate' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div class="text" [hidden]="!emailTemplate().templates.length">{{ emailTemplate().templates.length > 1 ? emailTemplate().selectedTemplate?.name : 'Default' }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind #4: post-stay REMINDER-EMAILS styling (edit-reminder-emails-styles.html).
       A 2-screen email-template picker (non-view / after-view) — NO CSS panel, NO styling
       payload (routed via getStylingEmailTemplateInjectables like invitation → activate +
       pending-changes skipped). Each screen shows the selected template name (or 'Default'
       when <2 templates); both bridged dropdown modals' on-done = updateReminderEmailTemplate
       (Styling.putReminderEmails). Loads both lists via Styling.getEmail. -->
  @case ('reminder-emails') {
    <div class="ft-alert-section">
      <div class="ft-alert">
        <div class="ft-alert-content">
          <p [innerHTML]="'flipto.account.ReminderEmailsTip' | translate"></p>
        </div>
      </div>
    </div>

    <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="non-view" style="display: inline-block;" (click)="screenName.set('non-view')"
                     [class.active]="screenName() === 'non-view'"
                     [innerHTML]="'flipto.account.ReminderNonViewTab' | translate"></a></li>
              <li><a class="after-view" style="display: inline-block;" (click)="screenName.set('after-view')"
                     [class.active]="screenName() === 'after-view'"
                     [innerHTML]="'flipto.account.ReminderAfterViewTab' | translate"></a></li>
            </ul>
          </div>
          <div class="ft-col-75">
            <ft-screen name="non-view">
              <div [hidden]="screenName() !== 'non-view'">
                <div class="ft-panel" (click)="showReminderNonViewTemplateModal()"
                     [class.read-only]="emailTemplate().nonViewTemplates.length < 2">
                  <div class="ft-row">
                    <div class="ft-col-33">
                      <div class="ft-label">{{ 'flipto.account.EmailTemplate' | translate }}:</div>
                    </div>
                    <div class="ft-col-66">
                      <div class="text" [hidden]="!emailTemplate().nonViewTemplates.length">{{ emailTemplate().nonViewTemplates.length > 1 ? emailTemplate().nonViewSelectedTemplate?.name : 'Default' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </ft-screen>

            <ft-screen name="after-view">
              <div [hidden]="screenName() !== 'after-view'">
                <div class="ft-panel" (click)="showReminderAfterViewTemplateModal()"
                     [class.read-only]="emailTemplate().afterViewTemplates.length < 2">
                  <div class="ft-row">
                    <div class="ft-col-33">
                      <div class="ft-label">{{ 'flipto.account.EmailTemplate' | translate }}:</div>
                    </div>
                    <div class="ft-col-66">
                      <div class="text" [hidden]="!emailTemplate().afterViewTemplates.length">{{ emailTemplate().afterViewTemplates.length > 1 ? emailTemplate().afterViewSelectedTemplate?.name : 'Default' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </ft-screen>
          </div>
        </div>
      </div>
    </section>
  }

  <!-- WS4 inc 6 grind #5: post-stay REENGAGEMENT-EMAILS styling (edit-reengagement-emails-styles.html).
       A 2-screen email-template picker (no-quote / no-photo), with the same conditional rule-warning
       as messaging. NO CSS panel, NO styling payload (getStylingEmailTemplateInjectables). Both bridged
       dropdown modals' on-done = updateReengagementEmailTemplate (Styling.putReengagementEmails). -->
  @case ('reengagement-emails') {
    <div class="ft-alert-section">
      <div class="ft-alert">
        <div class="ft-alert-content">
          @if (!reengagementPhotoExplorerActive) {
            <p class="ft-text-warning" [innerHTML]="'flipto.account.ReengagementEmailsRule' | translate"></p>
          }
          <p [innerHTML]="'flipto.account.ReengagementEmailsTip' | translate"></p>
        </div>
      </div>
    </div>

    <section class="ft-section ft-config-section has-sidenav">
      <div class="ft-container">
        <div class="ft-row">
          <div class="ft-col-25">
            <ul class="nav editor-nav">
              <li><a class="no-quote" style="display: inline-block;" (click)="screenName.set('no-quote')"
                     [class.active]="screenName() === 'no-quote'"
                     [innerHTML]="'flipto.account.ReengagementNoQuoteTab' | translate"></a></li>
              <li><a class="no-photo" style="display: inline-block;" (click)="screenName.set('no-photo')"
                     [class.active]="screenName() === 'no-photo'"
                     [innerHTML]="'flipto.account.ReengagementNoPhotoTab' | translate"></a></li>
            </ul>
          </div>
          <div class="ft-col-75">
            <ft-screen name="no-quote">
              <div [hidden]="screenName() !== 'no-quote'">
                <div class="ft-panel" (click)="showReengagementNoQuoteTemplateModal()"
                     [class.read-only]="emailTemplate().noQuoteTemplates.length < 2">
                  <div class="ft-row">
                    <div class="ft-col-33">
                      <div class="ft-label">{{ 'flipto.account.EmailTemplate' | translate }}:</div>
                    </div>
                    <div class="ft-col-66">
                      <div class="text" [hidden]="!emailTemplate().noQuoteTemplates.length">{{ emailTemplate().noQuoteTemplates.length > 1 ? emailTemplate().noQuoteSelectedTemplate?.name : 'Default' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </ft-screen>

            <ft-screen name="no-photo">
              <div [hidden]="screenName() !== 'no-photo'">
                <div class="ft-panel" (click)="showReengagementNoPhotoTemplateModal()"
                     [class.read-only]="emailTemplate().noPhotoTemplates.length < 2">
                  <div class="ft-row">
                    <div class="ft-col-33">
                      <div class="ft-label">{{ 'flipto.account.EmailTemplate' | translate }}:</div>
                    </div>
                    <div class="ft-col-66">
                      <div class="text" [hidden]="!emailTemplate().noPhotoTemplates.length">{{ emailTemplate().noPhotoTemplates.length > 1 ? emailTemplate().noPhotoSelectedTemplate?.name : 'Default' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </ft-screen>
          </div>
        </div>
      </div>
    </section>
  }

  <!-- WS4 inc 6 grind #8: photo-advocacy contestPage "Story Explorer" styling
       (edit-contestPage-styles.html) — a single flat CSS panel on model.styling.advancedCss
       (snapshot model.styling + commit; NOT a banner, NOT email-template). The integration tab
       stays v1 for now. -->
  @case ('contestPage') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" ft-modal-fields-editor (click)="editContestPageCss()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">{{ 'flipto.account.CSS' | translate }}:</div>
          </div>
          <div class="ft-col-66">
            <div class="css-text">{{ model().styling?.advancedCss }}@if (!(model().styling?.advancedCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: FRIEND LANDING styling (edit-landing-styles.html) — a 3-screen
       ft-nav-pane (signup / signup-guest / signup-hosted) of flat CSS panels on model.styling
       (advancedCss/advancedParentCss · advancedQuoteCss/advancedQuoteParentCss · advancedHostedCss).
       Flat-styling (snapshot model.styling + commit; NOT a banner, NOT email-template). The
       css-text uses text-binding ({{}} = v1 ng-bind) + the ft-placeholder ClickToEdit span. -->
  @case ('landing') {
  <section class="ft-section ft-config-section has-sidenav">
    <div class="ft-container">
      <div class="ft-row">
        <div class="ft-col-25">
          <ul class="nav editor-nav">
            <li><a class="signup" style="display: inline-block;" (click)="screenName.set('signup')"
                   [class.active]="screenName() === 'signup'"
                   [innerHTML]="('flipto.account.platform.preStay.touchpoints.SignUp' | translate | uppercase)"></a></li>
            <li><a class="signup-guest" style="display: inline-block;" (click)="screenName.set('signup-guest')"
                   [class.active]="screenName() === 'signup-guest'"
                   [innerHTML]="('flipto.account.platform.preStay.touchpoints.SignUpWithGuestQuote' | translate | uppercase)"></a></li>
            <li><a class="signup-hosted" style="display: inline-block;" (click)="screenName.set('signup-hosted')"
                   [class.active]="screenName() === 'signup-hosted'"
                   [innerHTML]="('flipto.account.HostedExperience' | translate | uppercase)"></a></li>
          </ul>
        </div>
        <div class="ft-col-75">
          <ft-screen name="signup">
            <div [hidden]="screenName() !== 'signup'">
              <div class="ft-panel" ft-modal-fields-editor (click)="editLandingTouchpointCss()">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">Touchpoint CSS:</div></div>
                  <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedCss }}@if (!(model().styling?.advancedCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
                </div>
              </div>
              <div class="ft-panel last" ft-modal-fields-editor (click)="editLandingParentCss()">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">Parent CSS:</div></div>
                  <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedParentCss }}@if (!(model().styling?.advancedParentCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
                </div>
              </div>
            </div>
          </ft-screen>

          <ft-screen name="signup-guest">
            <div [hidden]="screenName() !== 'signup-guest'">
              <div class="ft-panel" ft-modal-fields-editor (click)="editLandingQuoteCss()">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">Touchpoint CSS:</div></div>
                  <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedQuoteCss }}@if (!(model().styling?.advancedQuoteCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
                </div>
              </div>
              <div class="ft-panel last" ft-modal-fields-editor (click)="editLandingQuoteParentCss()">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">Parent CSS:</div></div>
                  <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedQuoteParentCss }}@if (!(model().styling?.advancedQuoteParentCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
                </div>
              </div>
            </div>
          </ft-screen>

          <ft-screen name="signup-hosted">
            <div [hidden]="screenName() !== 'signup-hosted'">
              <div class="ft-panel last" ft-modal-fields-editor (click)="editLandingHostedCss()">
                <div class="ft-row">
                  <div class="ft-col-33"><div class="ft-label">CSS:</div></div>
                  <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedHostedCss }}@if (!(model().styling?.advancedHostedCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
                </div>
              </div>
            </div>
          </ft-screen>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: FRIEND LANDING (mobile) styling (edit-mobile-styles.html) — a single
       flat CSS panel on model.styling.advancedCss (no nav-pane). Flat-styling (snapshot
       model.styling + commit). -->
  @case ('mobile') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel last" ft-modal-fields-editor (click)="editMobileCss()">
        <div class="ft-row">
          <div class="ft-col-33"><div class="ft-label">CSS:</div></div>
          <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedCss }}@if (!(model().styling?.advancedCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: PHOTO-RIVER "Story River" styling (edit-photo-river-styles.html) — a single
       flat CSS panel on model.styling.touchpointCSS (the bannerCss getter), saved via
       saveEmailImageStyling (whole-object PUT, NOT commit; no BannerSize/dimensions). -->
  @case ('photo-river') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel last" ft-modal-fields-editor (click)="editBannerCss()">
        <div class="ft-row">
          <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.CSS' | translate }}:</div></div>
          <div class="ft-col-66"><div class="css-text">{{ bannerCss }}@if (!bannerCss) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: HOMEPAGE "Homepage Component" styling (edit-homepage-styles.html) — two flat
       CSS panels (CssForPageContent=advancedParentCss / CssForSignUpDialog=advancedCss). -->
  @case ('homepage') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" ft-modal-fields-editor (click)="editHomepageParentCss()">
        <div class="ft-row">
          <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.CssForPageContent' | translate }}:</div></div>
          <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedParentCss }}@if (!(model().styling?.advancedParentCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
        </div>
      </div>
      <div class="ft-panel last" ft-modal-fields-editor (click)="editHomepageDialogCss()">
        <div class="ft-row">
          <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.platform.homepage.touchpoints.CssForSignUpDialog' | translate }}:</div></div>
          <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedCss }}@if (!(model().styling?.advancedCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind: QUOTE-LIST "Quotes List" styling (edit-list-styles.html) — a single flat
       CSS panel on model.styling.advancedParentCss (snapshot model.styling + commit). -->
  @case ('list') {
  <section class="ft-section ft-config-section">
    <div class="ft-container">
      <div class="ft-panel" ft-modal-fields-editor (click)="editListParentCss()">
        <div class="ft-row">
          <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.CSS' | translate }}:</div></div>
          <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedParentCss }}@if (!(model().styling?.advancedParentCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
        </div>
      </div>
    </div>
  </section>
  }

  <!-- WS4 inc 6 grind (LAST touchpoint editor): quote "Post-stay Process" styling
       (styling-version.html → ng-include edit-quote-styles-v2.html, the ACTIVE v2) — a single flat
       CSS panel on model.styling.advancedCss inside the version chrome (inert <ft-version-panel> empty
       on quebec + inert empty <ft-sheet-tabs> + .sheet-body; baseline-probed). NO colon on the CSS
       label (matches edit-quote-styles-v2.html, unlike contestPage/list). flatStyling → snapshot
       model.styling + commit. -->
  @case ('quote') {
    <ft-version-panel />
    <!-- Wrapped in the inert inline <ft-sheet-tabs> like v1 (and the contest sheets): a bare
         block div lets the empty <ul>'s 16px UA margin collapse up and shift the sheet down. -->
    <ft-sheet-tabs state-array="sheetTabs"><div class="sheet-tabs"><ul></ul></div></ft-sheet-tabs>
    <div class="sheet-body">
      <section class="ft-section ft-config-section">
        <div class="ft-container">
          <div class="ft-panel" ft-modal-fields-editor (click)="editQuoteCss()">
            <div class="ft-row">
              <div class="ft-col-33"><div class="ft-label">{{ 'flipto.account.CSS' | translate }}</div></div>
              <div class="ft-col-66"><div class="css-text">{{ model().styling?.advancedCss }}@if (!(model().styling?.advancedCss)) {<span class="placeholder">{{ 'flipto.account.ClickToEdit' | translate }}</span>}</div></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  }

  @default {
  <section class="ft-section ft-config-section">
    <div class="ft-container">

      <ul class="nav navbar-nav pane" [hidden]="!showBookingEnginesPanel()">
        @for (engine of model().bookingEngines; track engine) {
          <li>
            <a (click)="model().showEngineId = engine.id">{{ engine.name }}</a>
          </li>
        }
      </ul>

      @for (data of model().bookingEngines; track data; let i = $index) {
        <div [hidden]="model().showEngineId != data.id">
          <div class="ft-panel" ft-modal-fields-editor (click)="editTouchpointCss(i)">
            <div class="ft-row">
              <div class="ft-col-33">
                <div class="ft-label">Touchpoint CSS:</div>
              </div>
              <div class="ft-col-66">
                <div class="css-text">{{ data['advancedCss'] }}</div>
              </div>
            </div>
          </div>
          @if (data.confirmationDisplayTypeId != 3) {
            <div class="ft-panel last" ft-modal-fields-editor (click)="editParentCss(i)">
              <div class="ft-row">
                <div class="ft-col-33">
                  <div class="ft-label">Parent CSS:</div>
                </div>
                <div class="ft-col-66">
                  <div class="css-text">{{ data['advancedParentCss'] }}</div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </section>
  }

}
